import React from "react";
import { createSearchParams, Link } from "react-router-dom";
import { cities } from "../../../../Utils/contstant";
import { Color } from "../../../../Utils/styles";
import Loading from "../../../Common/Loading";
import { useReserve } from "../Hooks";
const SelectCity = ({ data, loading }) => {
  const { renderCategory, navigate } = useReserve();
  if (loading) {
    return (
      <div className="row justify-content-between">
        <Loading count={7} height={100} />
      </div>
    );
  }
  return (
    <div>
      {data.contentbox && data.contentbox.content ? (
        <div
          className="content-box"
          style={{
            padding: "20px 0px",
            color: "#404040",
            textAlign: "justify",
            fontWeight: "400",
            p: {
              fontWeight: "400",
            },
          }}
          dangerouslySetInnerHTML={{
            __html: data.contentbox.content,
          }}
        ></div>
      ) : (
        renderCategory(data).text && renderCategory(data).text()
      )}

      <div className="row mt-4 pb-5">
        {data.cities &&
          data.cities.map(button => {
            return <BtnCity button={button} />;
          })}
      </div>
    </div>
  );
};

export default SelectCity;
const BtnCity = ({ button, category = false }) => {
  const { renderCategory, navigate } = useReserve();
  const renderLink = () => {
    return `${button.slug}`;
  };
  return (
    <div className="col-md-4 mb-3 col-lg-3 ">
      <Link
        className="btn btn-light card-shadow-web"
        style={{ width: "100%", color: Color.black }}
        to={renderLink()}
      >
        {category
          ? `رزرو مجموعه های ${button.name}`
          : `رزرو ${renderCategory().name} های ${button.name}`}
      </Link>
    </div>
  );
};
